import { Input } from 'components/atoms';
import { useFormikField } from 'hooks/useFormikField';
import { IMaskInputProps } from 'types/components/inputs/input.interface';

const MaskInputForm = ({ name, isError = true, ...props }: IMaskInputProps) => {
  const [field, { error, value, status }] = useFormikField<string>(name);

  return (
    <Input.Mask
    displayMode={status?.displayMode}
    isLoading={status?.isLoading}
      {...props}
      {...field}
      value={value}
      error={error}
    />
  );
};

export default MaskInputForm;
